import Vue from 'vue'
import ModalConfirmation from '~/components/ModalConfirmation'
import ModalStatus from '~/components/ModalStatus'
import ModalWallet from '~/components/ModalWallet'
import ModalShare from '~/components/ModalShare'
import store from '~/store'

const VuePartial = Vue.extend({})

export default {
  confirmation: (props) => {
    const modal = new VuePartial({ ...ModalConfirmation , store, propsData: props })
    createArea()
    modal.$mount('#modal-area')
    modal.open()
  },

  status: (props) => {
    const modal = new VuePartial({ ...ModalStatus, store, propsData: props })
    createArea()
    modal.$mount('#modal-area')
    modal.open()
  },

  wallet: (props) => {
    const modal = new VuePartial({ ...ModalWallet, store, propsData: props })
    createArea()
    modal.$mount('#modal-area')
    modal.open()
  },

  share: (props) => {
    const modal = new VuePartial({ ...ModalShare, store, propsData: props })
    createArea()
    modal.$mount('#modal-area')
    modal.open()
  }
}

function createArea() {
  if (document.getElementById('modal-area')) return
  const div = document.createElement('div')
  div.id = 'modal-area'
  document.body.appendChild(div)
}